// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__32PBe","title":"ClientInsurance_title__34tj6","itemText":"ClientInsurance_itemText__1oALz"};